<template>
  <div class="date-time-picker">
    <DatePicker
      class="date-picker"
      v-model="date"
      type="date"
      transfer
      :placeholder="placeholder"
      :options="{
        disabledDate: disabledDate,
      }"
      @on-change="datePickerChange"
    />
    <TimePicker
      @on-change="timeSelectChange"
      format="HH:mm"
      class="time-picker"
      v-model="time"
      placeholder="请选择"
      :disabled-hours="disabledHours"
      :disabled-minutes="disabledMinutes"
    />
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "请选择日期",
    },
    disabledDate: {
      type: Function,
      default: () => false,
    },
    startHour: {
      type: Number,
      default: "",
    },
    endHour: {
      type: Number,
      default: "",
    },
    nowDate: {
      type: String,
      default: "",
    },
  },
  computed: {
    startTime() {
      let dS = dayjs().add(this.startHour, "hour");
      let str = "00:01";
      if (dayjs().isSame(this.date, "date")) {
        str = dS.format("HH:mm");
      }
      return str;
    },
    endTime() {
      let dE = dayjs().add(this.endHour, "hour");
      let str = "23:59";
      if (dE.isSame(this.date, "date")) {
        str = dE.format("HH:mm");
      }
      return str;
    },
    disabledHours() {
      let start = parseInt(this.startTime.split(":")[0]);
      let end = parseInt(this.endTime.split(":")[0]);
      let arr = [];
      for (let i = 0; i < 24; i++) {
        if (i < start || i > end) {
          arr.push(i);
        }
      }
      return arr;
    },
    disabledMinutes() {
      let nowTime = parseInt(this.time.split(":")[0]);
      let hourStart = parseInt(this.startTime.split(":")[0]);
      let hourEnd = parseInt(this.endTime.split(":")[0]);
      let start = parseInt(this.startTime.split(":")[1]);
      let end = parseInt(this.endTime.split(":")[1]);
      if (nowTime > hourStart) {
        start = 0;
      }
      if (nowTime < hourEnd) {
        end = 59;
      }
      let arr = [];
      for (let i = 0; i < 60; i++) {
        if (i < start || i > end) {
          arr.push(i);
        }
      }
      return arr;
    },
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue === oldValue) return;
      this.init();
    },
  },
  data() {
    return {
      date: "",
      time: "",
    };
  },
  methods: {
    init() {
      let d = this.value ? dayjs(this.value) : dayjs();
      this.date = d.format("YYYY-MM-DD");
      this.time = d.format("HH:mm:ss");
    },
    onEmit() {
      this.$emit(
        "input",
        dayjs(this.date).format("YYYY-MM-DD") + " " + this.time
      );
    },
    datePickerChange() {
      let b = dayjs().format("YYYY-MM-DD");

      let d1 = dayjs(b + " " + this.time).isAfter(
        dayjs(b + " " + this.endTime)
      );
      let d2 = dayjs(b + " " + this.time).isBefore(
        dayjs(b + " " + this.startTime)
      );

      if (d1) {
        this.time = this.endTime + ":00";
      } else if (d2) {
        this.time = this.startTime + ":00";
      }
      this.onEmit();
    },
    timeSelectChange() {
      this.onEmit();
    },
  },
  created() {
    this.init();
  },
};
</script>

<style scoped lang="scss">
.date-time-picker {
  width: 100%;
  display: flex;
  :deep {
    .date-picker {
      flex: 1;
      margin-right: 15px;
    }
    .time-picker {
      width: 190px;
      flex-shrink: 0;
    }
  }
}
</style>